import { render } from "./CreatePaymentLiquidation1.vue?vue&type=template&id=2379c71f"
import script from "./CreatePaymentLiquidation1.vue?vue&type=script&lang=js"
export * from "./CreatePaymentLiquidation1.vue?vue&type=script&lang=js"

import "./CreatePaymentLiquidation1.vue?vue&type=style&index=0&id=2379c71f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__